export { default } from './Activity.component';
